import usePartnerCompany from 'Hooks/usePartnerCompany';

export default function useSpanishPartner() {
	const { company } = usePartnerCompany();

	const isSpanishPartner = company?.country === 'ES';

	return { isSpanishPartner };
}
